import React, { PropTypes, Component } from 'react';
import Rating from './Rating';
import { loadMoreProductEntityFromCategory } from '../actions/HomeLoadCreator';
import { loadMoreServiceEntityFromCategory } from '../actions/HomeLoadCreator';
import Loader from 'react-loader';

class EntitiesListHorizontolContainer extends Component {
  static propTypes = {
    entities: PropTypes.object.isRequired
  }

  static defaultProps = {
    entities: {}
  }

  static contextTypes = {
    executeAction: React.PropTypes.func
  }
  componentWillMount(){
   // var temp = this.props.entities;
   //  var length = 3;
   //  var data = temp.filter(function(item, index) {
   //    return index < length;
   //  });
    var length = 0;
    var data = this.props.entities.filter(function(item, index){
      return index < length+3;
    });
   // var state = 0;
    this.state = {
      data: data,
      length: length,
      EntitiesLength: this.props.entities.length,
    };
  }

  render() {
    if (!Object.keys(this.props.entities).length) {
      return null;
    }

    const entities = this.state;
    return (
        <div className="entity-container homeentity-container">
          <i className="sprite-red sprite-Trending"></i>
          <text className="container-title">
            <span>Top Rated </span>
            {(entities.data.length!=0) ? entities.data[0].category : ''}
            <span> Restaurants</span>
          </text>
          {(entities.EntitiesLength >3)&&( 
          <div className="slider-container">
            <span className="left-arrow" onClick={ this.prevloadMore.bind(this, {
                                                     name: entities.name,
                                                     type: entities.type,
                                                     id: entities.id,
                                                     obj: entities
                                                   }) }>
                                      <i className="icon-angle-left" style={ { "font-size": "2em" } }></i>
                                  </span>
            <span className="right-arrow" onClick={ this.loadMore.bind(this, {
                                                      name: entities.name,
                                                      type: entities.type,
                                                      id: entities.id,
                                                      obj: entities
                                                    }) }>
                                      <i className="icon-angle-right" style={ { "font-size": "2em" } }></i>
                                  </span>
          </div>)}
          <div className="entity-maincarousel">
            <ul className="homeentity item-padding" id={ entities.id }>
              { entities.data.map(function(entity) {
                  return (
                    <li className="homeentity-li col-md-4 col-xs-4 col-sm-4">
                      <a href=''>
                        <div className="website-container homewebsite-container">
                          <img className="website-image" src={ entity.image } />
                          <div className="entity-container-title homeentity-container-title">
                            { (entity.title.length > 20) && (
                              <div className="entity-container-titlename">
                                { entity.title.replace(/&amp;/g, '&') }
                              </div>
                              ) }
                            { (entity.title.length <= 20) && (
                              <div className="entity-container-titlename">
                                { entity.title.replace(/&amp;/g, '&') }
                              </div>
                              ) }
                            {/*<div className="entity-container-rating">
                              <div style={ { "float": "left", "margin-right": "1em", "margin-top": "1em" } }>
                                <Rating entities={ entity } />
                              </div>
                              <div className="entity-container-reviewsbtn" style={ { "float": "left" } }>
                                { entity.rating_count } reviews</div>
                            </div>*/}
                          </div>
                        </div>
                      </a>
                    </li>
                    );
                }) }
            </ul>
          </div>
        </div>
      
      );
  }
  prevloadMore(entities) {
     var length = this.state.length;
      if(length >=3){
         length = this.state.length-3;
      // if(this.state.data.length != 3){
      //   var len = this.state.data.length; 
      //   len !=1 ? length = length - len: length = length - len-2;
      // }

         var data = this.props.entities.filter(function(item, index){
          return index >= length-3 && index < length ;
        });
         //if(length != 3){
          if((length >= 0)&&(data.length != 0)){
          this.setState({
            data: data,
            length: length,
          }); 
          }
         // }else{
         //  this.setState({
         //   data: data,
         //  }); 
         // } 
   }
    
  }
  loadMore(entities) {
    var length = this.state.length;
    console.log("next",length);
      if(this.state.length === 0 ){
        length = this.state.length+3;
      }
    if(length < this.props.entities.length){
     
      var data = this.props.entities.filter(function(item, index){
        return index >= length && index < length+3 ;
      });
      if((length < this.props.entities.length)&&(data.length != 0)){
        // if(this.state.length === 0){
        //   this.setState({
        //   data: data,
        //   length: length+3,
        //   });  
        // }else{
          this.setState({
            data: data,
            length: length+3,
          });  
        //}
        
       }else{
        

      }
    }
      
    //if (entity.length > this.state.data + 3) {
      // var length = this.state.data.length;
      // var data = entity.filter(function(item) {
      //   return index > length && index <= length + 3;
      // });
      // this.setState({
      //   data: data
      // });
      // $('#previous-btn').removeClass('disabled-btn');
    //} else {
      // $('#showmore-btn').addClass('disabled-btn');
    //}
    // if (entities.type === 'product') {
    //   this.context.executeAction(loadMoreProductEntityFromCategory, entities);
    // } else if (entities.type === 'service') {
    //   this.context.executeAction(loadMoreServiceEntityFromCategory, entities);
    // }
    // var entitylength = $('#' + entities.id + '').children().size();
    // var entitywidth = $('#' + entities.id + ' li').css('width').slice(0, -2);
    // var entityContainerWidth = entitywidth * entitylength;
    // $('#' + entities.id + '').css("width", entityContainerWidth);
    // var containerwidth = $('#' + entities.id + '').css("width").slice(0, -2);
    // var container = JSON.parse($('#' + entities.id + '').css("margin-left").slice(0, -2));
    // var containerlength = (container / 12);
    // var entityLeft = -((entitywidth / 12) + 1) * 3;

    // if (container < 0) {
    //   containerlength += entityLeft;
    //   if (container >= -containerwidth) {
    //     $('#' + entities.id + '').animate({
    //       "margin-left": containerlength + "em"
    //     }, "slow");
    //   }
    // } else {
    //   $('#' + entities.id + '').animate({
    //     "margin-left": entityLeft + "em"
    //   }, "slow");
    // }
  }
}
module.exports = EntitiesListHorizontolContainer;


// WEBPACK FOOTER //
// ./src/components/EntitiesListHorizontolContainer.js